/* eslint-disable @typescript-eslint/naming-convention */
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { mapToHttpParams } from '@bcl/design-system';

export type DictionaryKey = 'DATE.FILTER.OPTION';

@Injectable({
  providedIn: 'root',
})
export class DictionaryService {
  constructor(private http: HttpClient) {}

  public getDictionaryItemsByKey(
    key: string,
    locale?: string
  ): Observable<DictionaryItem[]> {
    const url = `${environment.apiHost}/dictionary/${key}`;
    const params = mapToHttpParams({ locale });

    return this.http.get<DictionaryItem[]>(url, { params });
  }

  public getDictionaryItems(key: string): Observable<DictionaryItem[]> {
    const url = `${environment.apiHost}/dictionary/${key}`;

    return this.http.get<DictionaryItem[]>(url);
  }

  public getDictionaryItemsByKeyV2(
    key: DictionaryItemV2Keys
  ): Observable<DictionaryItemV2> {
    const url = `${environment.apiHost}/dictionary/v2/${key}`;

    return this.http.get<DictionaryItemV2>(url);
  }

  public getActionTypes(): Observable<DictionaryItem[]> {
    return this.getDictionaryItems('ACTION.TYPE');
  }

  public getActionStatuses(): Observable<DictionaryItem[]> {
    return this.getDictionaryItems('ACTION.STATUS');
  }

  public getActionPriorities(): Observable<DictionaryItem[]> {
    return this.getDictionaryItems('ACTION.PRIORITY');
  }

  public getActionResponsibilities(): Observable<DictionaryItem[]> {
    return this.getDictionaryItems('ACTION.RESPONSABILITY');
  }
  public getDateFilters(): Observable<DictionaryItem[]> {
    return this.getDictionaryItems('DATE.FILTER.OPTION');
  }

  public getUsers(
    filterByOffice: boolean = true,
    getAll: boolean = false
  ): Observable<User[]> {
    const url = `${environment.apiHost}/users`;
    return this.http.get<User[]>(url, {
      params: mapToHttpParams({
        filterByOffice,
        getAll,
      }),
    });
  }
}

export type DictionaryItem = {
  id?: number;
  int1: number;
  key: string;
  name: string;
  text1: string;
  value: string;
  valueKey: string;
  additionalValues?: any;
};

export type User = {
  fullName: string;
  id: string;
};

export type DictionaryItemV2Keys =
  | 'TABLE.PC.PRODUCT.TYPES'
  | 'TABLE.PC.PRODUCT.GROUPS'
  | 'TABLE.PC.PRODUCT.UNITS'
  | 'TABLE.PC.MONITOR.INSTRUMENTS'
  | 'TABLE.EMPLOYEE.SKILLS'
  | 'LOCATION.TYPE'
  | 'TABLE.PC.PRODUCT'
  | 'PC.PRICEINDEXATION.STATUS'
  | 'PC.DEFAULT.SETTINGS'
  | 'PC.NONCONFORMITIES.CATEGORIES'
  | 'TABLE.NONCONFORMITY.STATUSES'
  | 'TABLE.NONCONFORMITY.TYPES'
  | 'TABLE.NONCONFORMITY.DIVISIONS'
  | 'TABLE.NC.INCIDENTSEVERITY'
  | 'TABLE.PC.INSTRUMENTTYPES';
export type DictionaryItemV2 = {
  Config: {
    label: string;
    rowProperty: string;
    dataType: string;
    type?: string;
    templateName?: string;
    dictionary: string;
  }[];
  Data: any[];
};
